// extracted by mini-css-extract-plugin
module.exports = {"root":"BitmapIcon_root__pQ_Z4","image":"BitmapIcon_image__hUSai"};